"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cheerio_1 = __importDefault(require("cheerio"));
var removeQuotations_1 = __importDefault(require("./removeQuotations"));
var removeTrailingWhitespaces_1 = __importDefault(require("./removeTrailingWhitespaces"));
var linkify_1 = __importDefault(require("./linkify"));
var enforceViewport_1 = __importDefault(require("./enforceViewport"));
var blockRemoteContent_1 = require("./blockRemoteContent");
var cheerio_utils_1 = require("./cheerio-utils");
var appendStyle_1 = __importDefault(require("./appendStyle"));
var fixBrokenHtml_1 = __importDefault(require("./fixBrokenHtml"));
var enhanceLinks_1 = require("./enhanceLinks");
/**
 * Parse an HTML email and make transformation needed before displaying it to the user.
 * Returns the extracted body of the message, and the complete message for reference.
 *
 * Beside the optional, this always:
 * - Remove comments
 * - Remove scripts
 * - Remove tracking pixels
 * - Remove trailing whitespaces
 */
function prepareMessage(emailHtml, options) {
    if (options === void 0) { options = {}; }
    var _a = options.noQuotations, noQuotations = _a === void 0 ? false : _a, _b = options.autolink, autolink = _b === void 0 ? false : _b, _c = options.enhanceLinks, enhanceLinks = _c === void 0 ? false : _c, _d = options.forceViewport, forceViewport = _d === void 0 ? false : _d, _e = options.noRemoteContent, noRemoteContent = _e === void 0 ? false : _e, _f = options.includeStyle, includeStyle = _f === void 0 ? false : _f, _g = options.remoteContentReplacements, remoteContentReplacements = _g === void 0 ? {} : _g;
    var result = {
        messageHtml: emailHtml,
        completeHtml: emailHtml,
        didFindQuotation: false,
    };
    result.completeHtml = fixBrokenHtml_1.default(result.completeHtml);
    result.messageHtml = result.completeHtml;
    if (autolink) {
        result.completeHtml = linkify_1.default(result.completeHtml);
        result.messageHtml = result.completeHtml;
    }
    var $ = cheerio_1.default.load(result.completeHtml);
    // Comments are useless, better remove them
    removeComments($);
    removeScripts($);
    removeTrackers($);
    if (enhanceLinks) {
        enhanceLinks_1.enhanceLinks($);
    }
    if (noRemoteContent) {
        blockRemoteContent_1.blockRemoteContentCheerio($, remoteContentReplacements);
    }
    if (forceViewport) {
        enforceViewport_1.default($, forceViewport);
    }
    if (includeStyle) {
        appendStyle_1.default($, includeStyle);
    }
    removeTrailingWhitespaces_1.default($);
    result.completeHtml = $.html();
    result.messageHtml = result.completeHtml;
    // Remove quotations
    if (noQuotations) {
        var didFindQuotation = removeQuotations_1.default($).didFindQuotation;
        // if the actions above have resulted in an empty body,
        // then we should not remove quotations
        if (cheerio_utils_1.containsEmptyText(cheerio_utils_1.getTopLevelElement($))) {
            // Don't remove anything.
        }
        else {
            result.didFindQuotation = didFindQuotation;
            removeTrailingWhitespaces_1.default($);
            result.messageHtml = $.html();
        }
    }
    return result;
}
function removeTrackers($) {
    var TRACKERS_SELECTORS = [
        // TODO: Improve by looking at inline styles as well
        'img[width="0"]',
        'img[width="1"]',
        'img[height="0"]',
        'img[height="1"]',
        'img[src*="http://mailstat.us"]',
    ];
    var query = TRACKERS_SELECTORS.join(', ');
    $(query).each(function (_, el) {
        $(el).remove();
    });
}
function removeScripts($) {
    $('script').each(function (_, el) {
        $(el).remove();
    });
}
function removeComments($) {
    $('*')
        .contents()
        .each(function (_, el) {
        if (el.type === 'comment') {
            $(el).remove();
        }
    });
}
exports.default = prepareMessage;
